module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "sec-2"
    }
  }, [_c('p', {
    staticClass: "center",
    staticStyle: {
      "font-size": "1.1em",
      "margin-bottom": "0.7em",
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "pz1-6"
    }
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "rgb(79,75,76)"
    },
    attrs: {
      "id": "A_QN"
    }
  }, [_vm._v("Praise For"), _c('br'), _vm._v("\n\t\t\t\t\tInterGenerate")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz1-7"
    }
  }, [_vm._v("\n\t\t\t\t\t“"), _c('i', [_vm._v("InterGenerate")]), _vm._v(" is a veritable encyclopedia for those wishing to build capacity for\n\t\t\t\t\tthe intergenerational church. These writers blend strong research with inspiring\n\t\t\t\t\tstories, and their solid biblical and theological foundations are embedded within\n\t\t\t\t\t‘ministry-in-the-trenches’ experiences. Every church leader will find actionable\n\t\t\t\t\twisdom in this collection.” ")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz1-8"
    }
  }, [_c('b', [_vm._v("—Sydney Hielema,")]), _vm._v(" PhD, Faith Formation Ministries, Christian Reformed Church, Canada,\n\t\t\t\t\tand author of "), _c('i', [_vm._v("Deepening the Colors")]), _vm._v(" and "), _c('i', [_vm._v("Vivid")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz1-9"
    }
  }, [_vm._v("\n\t\t\t\t\t“Rather than living in isolated, peer ministry paradigms that no longer work, "), _c('i', [_vm._v("InterGenerate")]), _vm._v("\n\t\t\t\t\toffers the church a bold, new vision of spiritual formation from cradle to grave.\n\t\t\t\t\tThis book imagines the body of Christ as a series of intimate, joy-filled, intergenerational\n\t\t\t\t\trelationships. ")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz1-10"
    }
  }, [_c('b', [_vm._v("—James Penner,")]), _vm._v(" Canadian youth sociologist and lead author of "), _c('i', [_vm._v("Hemorrhaging Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz1-11"
    }
  }, [_vm._v("\n\t\t\t\t\t“"), _c('i', [_vm._v("InterGenerate")]), _vm._v(" signals an exciting and important shift in conversations around ministry\n\t\t\t\t\tfor youth, children, and congregational care. Many of the authors have been on the\n\t\t\t\t\tfront lines, working to shift congregational attention to an intergenerational focus.\n\t\t\t\t\tThere is a lot to learn in these pages.” ")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz1-12"
    }
  }, [_c('b', [_vm._v("—Andrew Root,")]), _vm._v(" PhD, Professor of Youth and Family Ministry, Luther Seminary, and author\n\t\t\t\t\tof "), _c('i', [_vm._v("Faith Formation in a Secular Age")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz1-13"
    }
  }, [_vm._v("\n\t\t\t\t\t“The church is an intergenerational community, but the challenge for twenty-first-century\n\t\t\t\t\tleaders is to enhance it more intentionally. This book will equip you with a theoretical\n\t\t\t\t\tframework and praxis guidelines to become an effectively intergenerational church.”\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz1-14"
    }
  }, [_c('b', [_vm._v("—Jan Grobbelaar,")]), _vm._v(" PhD, Facilitator of Research and Academic Development, Petra Institute,\n\t\t\t\t\tDe Doorns, South Africa ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz1-15"
    }
  }, [_vm._v("\n\t\t\t\t\t“"), _c('i', [_vm._v("InterGenerate")]), _vm._v(" unleashes the potential for authentic, high-impact faith formation\n\t\t\t\t\tfor people of all ages. These diverse writers orient our thinking and provide practical\n\t\t\t\t\tstrategies to bring intergenerational ministries to life in the everyday relationships\n\t\t\t\t\tof everyday churches.” ")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz1-16"
    }
  }, [_c('b', [_vm._v("—Eugene Roehlkepartain,")]), _vm._v(" PhD, Vice President of Research and Development, Search Institute\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz1-17"
    }
  }, [_vm._v("\n\t\t\t\t\t“I’m thrilled by "), _c('i', [_vm._v("InterGenerate")]), _vm._v(". It is encouraging that so many academics and practitioners\n\t\t\t\t\thave united to develop and apply intergenerational ministry practices. Here you will\n\t\t\t\t\tfind the most up-to-date theory and practice of intergenerationality, written by\n\t\t\t\t\tpeople who love Christ’s church and desire to see all ages thrive together.” ")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz1-18"
    }
  }, [_c('b', [_vm._v("—Christine Lawton,")]), _vm._v(" PhD, Program Director of Institutional Assessment, Concordia University,\n\t\t\t\t\tand coauthor of "), _c('i', [_vm._v("Intergenerational Christian Formation")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz2-6"
    }
  }, [_vm._v("\n\t\t\t\t\t“The balance of academic ideas, theology, generational theory, and practical application\n\t\t\t\t\tmakes this an inspiring read. Rediscover the passionate conviction that the church\n\t\t\t\t\tis uniquely placed to make a transformational difference.” ")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "AOm"
    }
  }, [_c('b', [_vm._v("—Lucy Moore,")]), _vm._v(" Messy Church Founder and Team Leader, UK ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz2-7"
    }
  }, [_vm._v("\n\t\t\t\t\t“What Chesterton said about Christianity in general is also true of intergenerational\n\t\t\t\t\tministry: it ‘has not been tried and found wanting. It has been found difficult;\n\t\t\t\t\tand left untried.’ "), _c('i', [_vm._v("InterGenerate")]), _vm._v(" provides workable ideas to put intergenerational\n\t\t\t\t\tvision into practice. It is like a book of travel tips from those who have gone ahead\n\t\t\t\t\tin the journey.” ")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz2-8"
    }
  }, [_c('b', [_vm._v("—Rev. Dr. Graham Stanton,")]), _vm._v(" Centre for Children’s and Youth Ministry, Ridley College,\n\t\t\t\t\tAustralia ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz2-9"
    }
  }, [_vm._v("\n\t\t\t\t\t“"), _c('i', [_vm._v("InterGenerate")]), _vm._v(" is one-stop shopping for everything you need to know about intergenerational\n\t\t\t\t\tfaith formation. This stellar group of theorists and practitioners offers solid rationales\n\t\t\t\t\tand creative methodologies for becoming a faithful, intergenerational church.” ")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz2-10"
    }
  }, [_c('b', [_vm._v("—Ivy Beckwith,")]), _vm._v(" PhD, Faith Formation Ministry Team Leader, United Church of Christ,\n\t\t\t\t\tCleveland, OH ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz2-11"
    }
  }, [_vm._v("\n\t\t\t\t\t“Research consistently shows that worshiping across generations helps root young\n\t\t\t\t\tpeople in their faith. But where are the churches in which people worship, serve,\n\t\t\t\t\tand live out their faith across generations? Unable to imagine anything else, we\n\t\t\t\t\toften default to ‘church by age group.’ I welcome this book as a guide for churches\n\t\t\t\t\ton the transformational journey toward being intentionally intergenerational.” ")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz2-12"
    }
  }, [_c('b', [_vm._v("—Rev. Mary Hawes,")]), _vm._v(" National Children and Youth Adviser, Church of England ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz2-13"
    }
  }, [_vm._v("\n\t\t\t\t\t“Rediscover a shape of church where old and young accompany one another in developing\n\t\t\t\t\tfaith that is not only biblical but spiritually enriching for all. I hope this book\n\t\t\t\t\twill encourage churches to grow the all-age kingdom of God.” ")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz2-14"
    }
  }, [_c('b', [_vm._v("—Martyn Payne,")]), _vm._v(" author of "), _c('i', [_vm._v("Messy Togetherness")]), _vm._v(" and Messy Church team member, Bible Reading\n\t\t\t\t\tFellowship, UK ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz2-15"
    }
  }, [_vm._v("\n\t\t\t\t\t“The gift of this collection is the combined perspectives of practitioners and scholars.\n\t\t\t\t\tIt is the collective wisdom from a broad range of people who care about building\n\t\t\t\t\tcommunity across generations, and it is rooted in the guidance of God’s word.” ")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz2-16"
    }
  }, [_c('b', [_vm._v("—Gene Crume,")]), _vm._v(" PhD, President, Judson University, Elgin, IL ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz2-17"
    }
  }, [_vm._v("\n\t\t\t\t\t“There are few more pressing issues for the church today than the need to rediscover\n\t\t\t\t\twhat it means to actually live together in familial community. We are desperate for\n\t\t\t\t\thelp in not only recognizing our relational brokenness but also discovering how to\n\t\t\t\t\tdo something about it. "), _c('i', [_vm._v("InterGenerate")]), _vm._v(" is an invaluable resource for helping us to\n\t\t\t\t\tlive together as God’s people.” ")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz2-18"
    }
  }, [_c('b', [_vm._v("—Chap Clark,")]), _vm._v(" PhD, Pastor, St. Andrew’s Presbyterian Church, and author of "), _c('i', [_vm._v("Adoptive\n\t\t\t\t\tChurch")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a677eeae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter01.vue
// module id = 57
// module chunks = 0